export const statusOptionsRetake = [
  { value: 'PAYMENT_COMPLETED', label: '支払い済み' },
  { value: 'CANCELLATION_WAITING_LIST', label: 'キャンセル待ち' },
  { value: 'ADMIN_CANCELED', label: 'キャンセル' },
];

export const STATUS_RULES_RETAKE = {
  PAYMENT_COMPLETED: {
    CANCELLATION_WAITING_LIST: {
      index: 1,
      allow: false,
      error: '受付済みのためこのステータスには変更できません。',
    },
    ADMIN_CANCELED: {
      index: 2,
      allow: true,
      message: '受付を［キャンセル］します。この操作は戻せません。',
    },
  },
  CANCELLATION_WAITING_LIST: {
    PAYMENT_COMPLETED: {
      index: 1,
      allow: true,
      message: 'ステータスを［受付済み］に変更します。',
    },
    ADMIN_CANCELED: {
      index: 2,
      allow: true,
      message: '受付を［キャンセル］します。この操作は戻せません。',
    },
  },
  ADMIN_CANCELED: {
    PAYMENT_COMPLETED: {
      index: 1,
      allow: false,
      error:
        'この申し込みはキャンセルされました。\nアプリから再度申し込みするか、［個別追加］で再登録してください。',
    },
    CANCELLATION_WAITING_LIST: {
      index: 2,
      allow: false,
      error:
        'この申し込みはキャンセルされました。\nアプリから再度申し込みするか、［個別追加］で再登録してください。',
    },
  },
};

export const checkStatusTransition = (
  currentStatus,
  nextStatus,
  type = null
) => {
  const rule = STATUS_RULES_RETAKE[currentStatus]?.[nextStatus];

  if (currentStatus === nextStatus) {
    return { allow: false, error: null };
  } else if (!rule) {
    return { allow: false, error: 'No rule for status ...' };
  } else if (rule.require) {
    if (rule.require !== type) {
      return { ...rule, allow: true };
    } else {
      return { ...rule };
    }
  }

  return { ...rule };
};
